<div class="call-container">
  <div class="call-line headline bottom-spacing">
    <div [ngClass]="{ error: isContactNameError() }">
      {{ contactName }}
    </div>
    <div class="call-status-icon">
      @if (type === 'call' && callIcon) {
        <mat-icon
          [matTooltip]="callIcon.tooltip"
          matTooltipPosition="above"
          [color]="callIcon.color === 'success' || callIcon.color === 'muted' ? undefined : callIcon.color"
          [ngClass]="{
            'icon-success': callIcon.color === 'success',
            'icon-muted': callIcon.color === 'muted',
          }"
          >{{ callIcon.icon }}</mat-icon
        >
      }
      @if (type === 'message' && messageIcon) {
        <mat-icon
          [matTooltip]="messageIcon.tooltip"
          matTooltipPosition="above"
          [color]="messageIcon.color === 'success' ? undefined : messageIcon.color"
          [ngClass]="{ 'icon-success': messageIcon.color === 'success' }"
          >{{ messageIcon.icon }}</mat-icon
        >
      }
    </div>
  </div>
  <div class="headline bottom-spacing">
    @if (type === 'call') {
      <span>{{ formatPhone(call?.toFormatted || call?.to) }}</span>
    } @else if (type === 'message') {
      <span>{{ formatPhone(message?.to) }}</span>
    }
  </div>
  <div class="call-line date-duration-line">
    <div class="sub-headline">
      @if (type === 'call') {
        <span> {{ call?.created | date: 'medium' }} </span>
      } @else if (type === 'message') {
        <span> {{ message?.dateSent | date: 'medium' }}</span>
      }
    </div>
    @if (showCallDuration()) {
      <span class="sub-headline">{{ call?.duration || 0 | minuteSecond }}</span>
    }
  </div>
</div>
